import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let initialized = false;
let loaded = false;

/**
 * Loads the Google Places API via the JS API Loader.
 * No-ops if already loaded or if no API key is configured.
 *
 * Returns:
 *   Promise<void>: Resolves when the API is loaded (or skipped).
 */
export async function loadGooglePlaces(): Promise<void> {
  if (loaded) return;
  if (!import.meta.env.VITE_GOOGLE_PLACES_API_KEY) {
    console.warn('[googlePlaces] No API key configured (VITE_GOOGLE_PLACES_API_KEY)');
    return;
  }

  if (!initialized) {
    setOptions({
      key: import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
      v: 'weekly',
    });
    initialized = true;
  }

  await importLibrary('places');
  loaded = true;
}
